import React, { Fragment, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import Toast from "../../toast/SetToast";
import {
  notifyTopRight,
  notifyError,
} from "../../toast/SetToast";
import { useFirestore } from "../../../../hook/useFirestore";
import { ApproverEditForm } from "./ApproverEditForm";

const ApproverEdit = (props) => {
  const { updateDocument } = useFirestore("approvers");

  const inputRef = useRef({
    name: "",
    email: "",
    uid: "",
    status: "",
  });

  const handleChange = (name) => (e) => {
    inputRef.current[name] = e.target.value;
  };

  const handleOnHideModal = () => {
    props.hide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      name: inputRef.current.name
        ? inputRef.current.name
        : props.item.name,
      email: inputRef.current.email
        ? inputRef.current.email
        : props.item.email,
      uid: inputRef.current.uid
        ? inputRef.current.uid
        : props.item.uid,
      status: inputRef.current.status
        ? inputRef.current.status
        : props.item.status,
    };

    updateDocument(props.item.id, formData)
      .then(() => {
        notifyTopRight("บันทึกข้อมูลสำเร็จ");
      })
      .catch((err) => {
        notifyError("บันทึกข้อมูลผิดพลาด ", err);
      });

    props.hide();

    inputRef.current.name = "";
    inputRef.current.email = "";
    inputRef.current.uid = "";
    inputRef.current.status = "";
  };

  return (
    <Fragment>
      <Toast />
      <Modal
        className="fade bd-example-modal-lg"
        show={props.show}
        onHide={handleOnHideModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Edit Approver Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ApproverEditForm
            onChange={handleChange}
            initailValues={props.item}
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleSubmit}>
            Save
          </Button>
          <Button
            className="sm ml-2"
            variant="light"
            onClick={handleOnHideModal}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
};

export default ApproverEdit;
